
export const defaultParamsReport = () => {
    return {
        provider_id: null,
        dateYear: ''
    };
};

export default {
    ag_grid: {
        selectedTheme: "ag-theme-balham"
    },
    paramsReport: defaultParamsReport(),
    consignmentProductsPreInvoiceData: []
};



// WEBPACK FOOTER //
// ./src/modules/consignment-products-pre-Invoice/state.js